'use client'

import { useCallback, useRef, useState } from 'react'

import { useUserProfile } from '../../hooks/useUserProfile'

import { cn } from '@/shared/lib/utils'
import { Button } from '@/shared/ui/Button'
import {
  Modal,
  ModalBody,
  ModalHeader,
  ModalTitle,
  ModalFooter
} from '@/shared/ui/Modal'

import {
  AvatarCatalogPanel,
  type AvatarCatalogPanelHandle
} from './AvatarCatalogPanel'


interface UserProfileEditAvatarModalProps {
  onSave?: () => void
  onHide?: () => void
}

export const UserProfileEditAvatarModal = ({
  onSave,
  onHide: _onHide
}: UserProfileEditAvatarModalProps) => {
  const { refetchUserProfile } = useUserProfile({ me: true })
  const panelRef = useRef<AvatarCatalogPanelHandle>(null)
  const [saving, setSaving] = useState(false)
  const [appearanceDirty, setAppearanceDirty] = useState(false)

  const handleAvatarChanged = useCallback(async () => {
    await refetchUserProfile()
    onSave?.()
  }, [onSave, refetchUserProfile])

  const handleSalvar = useCallback(async () => {
    setSaving(true)
    try {
      await panelRef.current?.saveSelections()
    } finally {
      setSaving(false)
    }
  }, [])

  return (
    <Modal
      asCard
      className="max-w-2xl w-[92%] max-h-[min(92dvh,820px)] flex flex-col min-h-0"
    >
      <ModalHeader>
        <ModalTitle>Personalizar aparência</ModalTitle>
      </ModalHeader>
      <ModalBody
        className={cn(
          'min-h-0 flex-1 overflow-hidden flex flex-col gap-1.5 py-2.5',
          'max-h-[min(78dvh,680px)]'
        )}
      >
        <AvatarCatalogPanel
          ref={panelRef}
          onAvatarChanged={handleAvatarChanged}
          onDirtyChange={setAppearanceDirty}
        />
      </ModalBody>
      <ModalFooter className="shrink-0">
        <Button
          type="button"
          variant="primary"
          className="w-full"
          disabled={saving || !appearanceDirty}
          loading={saving}
          onClick={() => void handleSalvar()}
        >
          {saving ? 'Salvando…' : 'Salvar'}
        </Button>
      </ModalFooter>
    </Modal>
  )
}
